import HorizontalSpinner from './HorizontalSpinner'

type SuspenseFallbackProps = {
  withPadding: boolean
}

const SuspenseFallback = (props: SuspenseFallbackProps) => {
  const { withPadding = true } = props
  const spinner = <HorizontalSpinner size="large" />

  if (withPadding) {
    return <div className="p">{spinner}</div>
  } else {
    return spinner
  }
}

export default SuspenseFallback
